import { decodeWords } from '../mime-enc/decode-words';
import { StringDecoder } from '../types';
import { WithWarnings } from '../warnings';
import { ParsedDecodedHeaders } from './parseAndDecodeHeaders.types';
import { parseHeaders } from './parseHeaders';
import { HeaderParseOptions } from './parseHeaders.types';
import { parseHeaderValueAndParams } from './parseHeaderValueAndParams';
import { ParsedHeaderValue } from './parseHeaderValueAndParams.types';

const headersWithParams = new Set(['content-type', 'content-disposition']);

/**
 * @deprecated
 * This function decodes words in some structured fields, e.g. address fields,
 * before doing the destructuring. This is wrong as per
 */
export function parseAndDecodeHeaders(
	headers: string | Buffer,
	decode: StringDecoder,
	options?: HeaderParseOptions
): WithWarnings<ParsedDecodedHeaders> {
	const result = parseHeaders(headers, options);
	const rawHeaders = result.result;

	const decodedHeaders: ParsedDecodedHeaders = {};

	for (const headerKey in rawHeaders) {
		const values = rawHeaders[headerKey];
		if (values && values.length) {
			if (headersWithParams.has(headerKey)) {
				// This header may have extra parameters... decode these separately
				decodedHeaders[headerKey] = values.map(val =>
					parseHeaderValueAndParams(val, decode)
				);
			} else {
				// This header shouldn't have extra parameters... decode as single value
				decodedHeaders[headerKey] = values.map(str => {
					const struct: ParsedHeaderValue = {
						value: decodeWords(str, decode),
						params: {},
					};
					return struct;
				});
			}
		}
	}

	return {
		...result,
		result: decodedHeaders,
	};
}
